export default "__VITE_ASSET__3a330ab7__"